module.exports = __webpack_public_path__ + "assets/img/8.0e89382e.png";